





















































import Vue from 'vue';
import type { Location } from 'vue-router';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoLogo from '@/components/global/BravadoLogo/BravadoLogo.vue';
import { INDEX_PAGE } from '@/constants';
import { OnboardingSuggestedProductPathKey } from '@/components/partials/connections/types';
import { IS_SELECTED_JOBS_PRODUCT } from '@/components/partials/jobs/constants';

export default Vue.extend({
  name: 'HeaderLanding',
  components: {
    BravadoButtonV3,
    BravadoLogo,
  },
  props: {
    showOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mainPage(): Location {
      return INDEX_PAGE;
    },
    showHeaderButtons(): boolean {
      return Boolean(this.$auth.user) || !(this.$route.name === this.$pages.JOBS_WELCOME_PAGE.name);
    },
    isMobile(): boolean {
      return !this.$breakpoint.smAndUp;
    },
  },
  methods: {
    handleLoginClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__login-link__click');
      // @ts-ignore
      this.$modal.showWithRoute('SIGN_IN_MODAL');
    },
    handleSignUpClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__signup-button__click');
      // @ts-ignore
      this.$cookies.remove(IS_SELECTED_JOBS_PRODUCT);
      // @ts-ignore
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
    handleSalesJobsClick(): void {
      this.logEventWithButtonPosition('position1');
      // @ts-ignore
      this.$cookies.set(IS_SELECTED_JOBS_PRODUCT, OnboardingSuggestedProductPathKey.JobsProfile);
      // @ts-ignore
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
    logEventWithButtonPosition(position: string) {
      // @ts-ignore
      this.$analytics.logEvent('war-room__landing__cta-button__click', {
        button_location: position,
      });
    },
  },
});
